import store from "../../vuex/store.js";

export function canAccessReporting() {
  if(store.state.auth.user){
    const { userRole, enableReporting } = store.state.auth.user;
    if(+userRole !== 3 && +userRole !== 12) return true;
    return (+userRole === 3 || +userRole === 12) && enableReporting;
  }
  return false;
}

export function reportingAdmin() {
  if (store.state.auth.user) {
    const { userRole, enableReporting } = store.state.auth.user;
    return +userRole === 9 || (+userRole === 7 && enableReporting);
  }
  return false;
}

export function queueAdmin() {
  if (store.state.auth.user) {
    return +store.state.auth.user.userRole === 7;
  }
  return false;
}
